import React from 'react';
import Image from 'next/legacy/image';
import { Button, H1, TextLg } from 'atoms';
import { useDispatchUi } from 'context/ui';
import { useRouter } from 'next/router';

interface Props {
    heading?: string;
    subhead?: string;
    richText?: string;
    img: any;
    ctalink?: string;
    ctalabel?: string;
    videoLink?: any;
    headerContent?: any; // an arbitrary content block that is shown at the top (used on partner landing pages)
    background?: string;
    style?: any;
    flipSides?: boolean;
}

const Hero = ({ heading, subhead, richText, img, ctalink, ctalabel, videoLink, headerContent, background, style, flipSides = false }: Props) => {
    const dispatch: any = useDispatchUi();
    const router = useRouter();
    return (
        <div id='hero' style={style}>
            {headerContent && <div className='header-content'>{headerContent}</div>}
            <div id='hero-content' className={`${flipSides ? 'flip' : ''}`}>
                <div id='hero-left'>
                    <div style={{ width: '100%' }}>{img && <Image src={img.url} height={img.height} width={img.width} alt={img.alt} loading='lazy' />}</div>
                </div>
                <div id='hero-right'>
                    <H1 pb={5}>{heading}</H1>
                    <TextLg textVariant='light'>{subhead}</TextLg>
                    {Boolean(richText) && (
                        <TextLg textVariant='light'>
                            <div dangerouslySetInnerHTML={{ __html: richText }} />
                        </TextLg>
                    )}
                    {ctalabel && ctalink && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Button
                                mt={5}
                                onClick={(e: any) => {
                                    e.preventDefault();
                                    router.push(ctalink);
                                }}
                            >
                                {ctalabel}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            <style jsx>
                {`
                    #hero {
                        position: relative;
                        padding: 96px 60px 96px 60px;
                        background: ${background ?? 'linear-gradient(180deg, #fcf9fb 0%, #ffdef2 100%)'};
                    }

                    .flip {
                        flex-direction: row-reverse;
                    }

                    #hero-content {
                        margin: 0 auto;
                        max-width: 1280px;
                        display: flex;
                        align-items: center;
                    }

                    #hero-left {
                        width: 100%;
                        padding-right: 56px;
                    }

                    #hero-right {
                        width: 100%;
                    }

                    .header-content {
                        font-family: Avenir, serif;
                        font-style: normal;
                        font-weight: 900;
                        font-size: 36px;
                        line-height: 49px;
                        text-align: center;
                        color: #040404;
                    }

                    @media (max-width: 992px) {
                        #hero {
                            padding: 80px 40px 80px 40px;
                        }

                        #hero-content {
                            flex-direction: column-reverse;
                        }

                        #hero-left {
                            padding-right: 0px;
                        }

                        #hero-right {
                            width: 100%;
                            padding: 48px 0px 16px 0px;
                        }

                        #watch-video {
                            display: none;
                        }
                    }

                    @media (max-width: 480px) {
                        #hero {
                            padding: 80px 20px 48px 20px;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default Hero;
